import React from 'react';
import { siteData } from '../data/mock';

const Engagements = () => {
  const { engagements } = siteData;
  
  return (
    <article className="space-y-14 sm:space-y-20">
      {/* Header */}
      <header>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light text-[#1a1a1a] leading-snug sm:leading-tight tracking-tight">
          {engagements.title}
        </h1>
      </header>
      
      {/* How We Engage */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {engagements.intro.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {engagements.intro.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* Engagement Archetypes */}
      <section className="space-y-6 sm:space-y-8">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {engagements.archetypes.title}
        </h2>
        <div className="space-y-6 sm:space-y-8">
          {engagements.archetypes.items.map((item, i) => (
            <div key={i} className="space-y-2">
              <h3 className="text-[#1a1a1a] text-base font-medium">
                {item.title}
              </h3>
              <p className="text-[#2a2a2a] text-base leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </section>
      
      {/* What Engagements Are Not */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {engagements.notList.title}
        </h2>
        <ul className="space-y-2.5 sm:space-y-2 text-[#2a2a2a] text-base leading-relaxed">
          {engagements.notList.points.map((point, i) => (
            <li key={i} className="flex">
              <span className="mr-3 text-[#999999] flex-shrink-0">—</span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
      </section>
      
      {/* How We Work */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {engagements.howWeWork.title}
        </h2>
        <div className="space-y-1 text-[#2a2a2a] text-base leading-relaxed">
          {engagements.howWeWork.points.map((point, i) => (
            <p key={i}>{point}</p>
          ))}
        </div>
      </section>
      
      {/* Next */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {engagements.next.title}
        </h2>
        <p className="text-[#2a2a2a] text-base leading-relaxed">
          <a 
            href={`mailto:${engagements.next.email}`}
            className="underline underline-offset-4 decoration-[#cccccc] hover:decoration-[#1a1a1a] transition-colors break-all sm:break-normal"
          >
            {engagements.next.email}
          </a>
        </p>
      </section>
    </article>
  );
};

export default Engagements;
